import { api_host, default_environment } from '../AppConf';
require('whatwg-fetch');

class ApiCom {
  constructor() {
    this._state = {};
  }

  getState = ()  => {
    return this._state;
  }

  getPluginConfig = (partner_id, environment = default_environment) => {
    return new Promise((resolve, reject) => {
      fetch(api_host[environment || default_environment] + '/api/config/' + partner_id, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Parse-Application-Id': 'Revieve API'
        }
      })
      .then((response) => {
        if (response.status < 200 || response.status >= 300) {
          reject(response.statusText);
        }
        return response.json();
      })
      .then((response) => {
        this._state.config = response.config;
        resolve(response.config);
      })
      .catch((error) => {
        reject(error);
      });
    });
  }
}

export default ApiCom;


// WEBPACK FOOTER //
// ./src/services/ApiCom.js